export const DESKTOP_MAX_PRODUCTS_PER_PAGE = 96;
export const MAX_ORDERS_PER_PAGE = 12;
export const MAX_VOUCHERS_PER_PAGE = 12;
export const MOBILE_MAX_PRODUCTS_PER_PAGE = 24;
